var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sync") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#27cb6b;}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(-0.356)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.66,10.37a.62.62,0,0,0,.07-.19l.75-4a1.016,1.016,0,1,0-2-.36l-.37,2a9.22,9.22,0,0,0-16.58.84,1,1,0,0,0,1.86.75A7.08,7.08,0,0,1,12.07,5a7.17,7.17,0,0,1,6.24,3.58l-1.65-.27a1.013,1.013,0,1,0-.32,2l4.25.71h.16a.93.93,0,0,0,.34-.06.33.33,0,0,0,.1-.06.78.78,0,0,0,.2-.11l.08-.1a1.07,1.07,0,0,0,.14-.16.58.58,0,0,0,.05-.16Zm-1.78,3.7a1,1,0,0,0-1.31.56A7.08,7.08,0,0,1,11.93,19a7.17,7.17,0,0,1-6.24-3.58l1.65.27H7.5a1,1,0,1,0,.16-2L3.41,13a.91.91,0,0,0-.33,0H3a1.15,1.15,0,0,0-.32.14,1,1,0,0,0-.18.18l-.09.1a.84.84,0,0,0-.07.19.44.44,0,0,0-.07.17l-.75,4A1,1,0,0,0,2.32,19H2.5a1,1,0,0,0,1-.82l.37-2a9.22,9.22,0,0,0,16.58-.83,1,1,0,0,0-.57-1.28Z",
    transform: "translate(0.041)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.da4fcb831c84a8ab3f07c2fa24271299.svg";
export { ForwardRef as ReactComponent };